import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { MwInputFile, MwSpinnerButton } from '../../../components/ui'
import { useCurrent, usePost } from '../../../hooks';

const ImportExcel = ({callbackImported}) => {
    const {currentTenantId,currentCompanyId,currentBranchId,userId} = useCurrent();
    const {data:storeResul,postData} = usePost();
    const [dataLength, setDataLength] = useState(0);
    const [stored,setStored] = useState();
    const [data, setData] = useState([]);
    const [loadingImport, setLoadingImport] = useState(false);
    const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
        const workbook = XLSX.read(event.target.result, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        setData(jsonData);
        };
        reader.readAsArrayBuffer(file);
    };
  
    const productHandler = (_obj) => {
        if(_obj.length > 0){
            setDataLength(1)
            setLoadingImport(true);
            
            const promises = _obj.map( (row,index) => {
                return new Promise((resolve) => {
                    setTimeout(async() => {
                        await postData(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/`,row)
                        setDataLength((state) => state + 1 )
                        setStored(row)
                        resolve();
                    },index * 2000)
                    
                });
            });

            Promise.all(promises).then(() => {
                setLoadingImport(false);
                callbackImported()
            });
        }
    }

    useEffect(() => {
        let _obj = [];
        if(data.length > 0){
            setLoadingImport(true)
            console.log(data);
            data.forEach((row,index) => {
                    if(row['PRODUCT_NAME'] && row['UNIT_CODE'] && row['QTY_IN_STOCK'] && row['PRICE_PURCHASE'] && row['PRICE_SALE']  ){
                        _obj[index]={
                            product: {
                                productName:[{text:row['PRODUCT_NAME']}]
                            } ,
                            uom:{label:row['UNIT_CODE']},
                            pricePurchase:row['PRICE_PURCHASE'] ,
                            priceSale:row['PRICE_SALE'],
                            stockBalance : row['QTY_IN_STOCK'] || 0,
                            systemBalance :   0,
                            balance :   0
                        }
                    }
               // }
            });
            setLoadingImport(false)
            callbackImported(_obj)
            console.log('obj', _obj)
        }
    },[data]);

    return (
        <>
            <div className="w-full px-5 py-1 rounded-lg flex flex-row gap-5    bg-slate-100">
                { loadingImport ? <MwSpinnerButton withLabel={false} /> 
                                    : 
                                    <div className="flex-1 flex  gap-5 justfy-between items-center">
                                        <div className="flex-1  text-slate-500  text-end " >استيراد المنتجات من ملف </div>
                                        <MwInputFile id='file' acceptTypes='xlsx' onChangeHandler={handleFileChange} isSmall={true} />
                                        <div className="flex-1 text-xs font-bold text-violet-500"> <a target='_blank' href='https://4sharks-absat.s3.eu-north-1.amazonaws.com/inventory/absat-stocktakings-example.xlsx' >تحميل ملف كمثال</a> </div>
                                    </div>
                }
            </div>
        </>
    )
    
}

export default ImportExcel